import * as React from 'react';
import { Button, Paper } from '@mui/material';
import CopyToTrain from './CopyToTrain';
import DownloadDocumentsToolNav from './DownloadDocumentsToolNav';
import DownloadTokenized from './DownloadTokenized';
import { ToolActionsContext } from '../../../../context/ToolActionsContext';

export interface ToolActionsProps {
  review: boolean;
  docLabel: string;
  tokenizerVersion: string | undefined;
}

const ToolActions: React.FC<ToolActionsProps> = ({ review, docLabel, tokenizerVersion }) => {
  const { setIsReview, setOpen, open } = React.useContext(ToolActionsContext);

  React.useEffect(() => {
    setIsReview(review);
  }, [setIsReview, review]);

  return (
    <>
      <Button
        style={{ margin: '0 0.5em' }}
        variant="outlined"
        color="primary"
        data-cy="btn-tool-nav-menu"
        onClick={() => {
          setOpen(!open);
        }}
      >
        ...
      </Button>

      <Paper
        id="tool-actions-menu"
        style={{
          position: 'absolute',
          zIndex: 1150,
          right: 0,
          display: `${open ? '' : 'none'}`,
        }}
      >
        <DownloadDocumentsToolNav />
        {review && <CopyToTrain />}
        <DownloadTokenized docLabel={docLabel} tokenizerVersion={tokenizerVersion} />
        {/* <DeleteDocument /> */}
      </Paper>
    </>
  );
};

export default ToolActions;
